import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';

/** The `error` value the backend sends (GlobalExceptionHandler.ACCOUNT_NOT_PROVISIONED). */
export const ACCOUNT_NOT_PROVISIONED = 'Account Not Provisioned';

/** A 403 saying the token is fine but e-Portal has never created this person's account. */
export function isAccountNotProvisioned(error: unknown): boolean {
  return error instanceof HttpErrorResponse
    && error.status === 403
    && error.error?.error === ACCOUNT_NOT_PROVISIONED;
}

/**
 * Full-page stop shown instead of the app shell when the signed-in Keycloak account has no
 * row in the portal's user table: nothing in Supply Chain works without it, and only a sign-in
 * to e-Portal creates it — so the page sends them there.
 */
@Component({
  selector: 'app-account-not-provisioned',
  standalone: true,
  templateUrl: './account-not-provisioned.component.html',
  styleUrl: './account-not-provisioned.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountNotProvisionedComponent {
  /** Keycloak username / display name, so the person can tell which account is signed in. */
  readonly username = input<string | null>(null);
  readonly goToPortal = output<void>();
  readonly logout = output<void>();
}
